import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { api, setAuthToken } from '../services/api';
import { APP_VERSION, BUILD_NUMBER } from '../version';

function Landing() {
  const { login } = useAuth();
  const [activePanel, setActivePanel] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  async function handleGuestLogin() {
    setError('');
    setLoading(true);
    try {
      const { token, user } = await api.loginGuest();
      setAuthToken(token);
      login(token, user);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }

  async function handleLogin(e, role) {
    e.preventDefault();
    if (!username.trim() || !password) return;
    setError('');
    setLoading(true);
    try {
      const { token, user } = await api.login(username.trim(), password);
      if (role === 'admin' && user.role === 'player') {
        setError('Dieses Konto hat keine Admin-Rechte');
        setLoading(false);
        return;
      }
      setAuthToken(token);
      login(token, user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  function selectPanel(panel) {
    if (panel === 'guest') {
      handleGuestLogin();
      return;
    }
    setActivePanel(panel);
    setError('');
    setUsername('');
    setPassword('');
  }

  const bgStyle = {
    background: `url(${process.env.PUBLIC_URL}/mc-background.png) center center / cover no-repeat fixed`,
  };

  return (
    <div className="landing-page" style={bgStyle}>
      <div className="landing-container">
        <div className="landing-header">
          <div className="landing-title">LexWar's Minecraft Versteck</div>
          <p className="landing-subtitle">Server Management Panel</p>
        </div>

        {!activePanel ? (
          <div className="landing-cards">
            <div className={`landing-card landing-card-guest ${loading ? 'disabled' : ''}`} onClick={() => selectPanel('guest')}>
              <div className="landing-card-icon">&#128065;</div>
              <h2>Zuschauer</h2>
              <p>Server-Status ansehen</p>
              <span className="landing-card-badge">Kein Login</span>
            </div>

            <div className="landing-card landing-card-player" onClick={() => selectPanel('player')}>
              <div className="landing-card-icon">&#9876;&#65039;</div>
              <h2>Spieler</h2>
              <p>Server-Infos & Downloads</p>
              <span className="landing-card-badge">Login erforderlich</span>
            </div>

            <div className="landing-card landing-card-admin" onClick={() => selectPanel('admin')}>
              <div className="landing-card-icon">&#128736;</div>
              <h2>Admin</h2>
              <p>Server verwalten</p>
              <span className="landing-card-badge">Login erforderlich</span>
            </div>

            {error && <div className="landing-error" style={{ gridColumn: '1 / -1' }}>{error}</div>}
          </div>
        ) : (
          <div className="landing-form-container">
            <button className="landing-back-btn" onClick={() => setActivePanel(null)}>
              &lt; Zurueck
            </button>

            {activePanel === 'player' && (
              <div className="landing-form-panel">
                <div className="landing-form-icon">&#9876;&#65039;</div>
                <h2>Spieler-Login</h2>
                <p className="text-muted">Server-Infos, Downloads und Regeln</p>
                <form onSubmit={(e) => handleLogin(e, 'player')}>
                  <div className="form-group">
                    <label>Benutzername</label>
                    <input
                      className="form-input"
                      value={username}
                      onChange={e => setUsername(e.target.value)}
                      placeholder="Benutzername"
                      autoFocus
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Passwort</label>
                    <input
                      className="form-input"
                      type="password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      placeholder="Passwort"
                      required
                    />
                  </div>
                  {error && <div className="landing-error">{error}</div>}
                  <button className="btn btn-primary landing-submit-btn" type="submit" disabled={loading}>
                    {loading ? <span className="spinner" /> : 'Einloggen'}
                  </button>
                </form>
              </div>
            )}

            {activePanel === 'admin' && (
              <div className="landing-form-panel">
                <div className="landing-form-icon">&#128736;</div>
                <h2>Admin-Login</h2>
                <p className="text-muted">Voller Zugriff auf die Server-Verwaltung</p>
                <form onSubmit={(e) => handleLogin(e, 'admin')}>
                  <div className="form-group">
                    <label>Benutzername</label>
                    <input
                      className="form-input"
                      value={username}
                      onChange={e => setUsername(e.target.value)}
                      placeholder="Admin-Benutzername"
                      autoFocus
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Passwort</label>
                    <input
                      className="form-input"
                      type="password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      placeholder="Admin-Passwort"
                      required
                    />
                  </div>
                  {error && <div className="landing-error">{error}</div>}
                  <button className="btn btn-primary landing-submit-btn" type="submit" disabled={loading}>
                    {loading ? <span className="spinner" /> : 'Einloggen'}
                  </button>
                </form>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="landing-version">v{APP_VERSION} &middot; Build {BUILD_NUMBER}</div>
    </div>
  );
}

export default Landing;
